import { useEmailGlobalContext } from "@easy-email-pro-core/utils/EditorCore/contexts/EmailGlobalContext";
import { useEmailRenderContext } from "@easy-email-pro-core/utils/EditorCore/contexts/EmailRenderContext";
import React from "react";

export const Style: React.FC<{
  children: string;
  inline?: "inline";
  id?: string;
}> = (props) => {
  const { context } = useEmailGlobalContext();
  const { mode } = useEmailRenderContext();

  if (mode === "production") {
    context.addStyle({ ...props, content: props.children });
    return <></>;
  }
  return <style>{props.children}</style>;
};
